import serviceOpcion from '@/services/GsEncuesta/opcion'

export default {
  OPCION_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      serviceOpcion.findAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  OPCION_FIND_HIJOS(_, params) {
    return new Promise((resolve, reject) => {
      serviceOpcion.findHijos(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  OPCION_CREATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceOpcion.create(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  OPCION_UPDATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceOpcion.update(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  OPCION_DELETE(_, params) {
    return new Promise((resolve, reject) => {
      serviceOpcion.delete(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
